import * as moment from "moment";

export const serializePost = post => {
  post.moment = moment(post.fields.date)
  return post;
}
